var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "27px",
    viewBox: "0 0 32 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder_actief_icon",
    transform: "translate(-4.000000, -7.000000)",
    fill: "#F7893C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.277,7 C18.228,7 19,7.772 19,8.724 L19,8.724 L19,12 L34.277,12 C35.228,12 36,12.772 36,13.724 L36,13.724 L36,32.276 C36,33.228 35.228,34 34.277,34 L34.277,34 L5.724,34 C4.772,34 4,33.228 4,32.276 L4,32.276 L4,13.724 C4,12.772 4.772,12 5.724,12 L5.724,12 L8.277,12 L8.277,8.724 C8.277,7.772 9.048,7 10,7 L10,7 Z M33,15 L7,15 L7,31 L33,31 L33,15 Z M17.001,9 L10.277,9 L10.277,12 L17.001,12 L17.001,9 Z",
    id: "Fill-1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOrange);
export default __webpack_public_path__ + "static/media/fileOrange.eb608ea9f5680f6fe958ac86771b925a.svg";
export { ForwardRef as ReactComponent };